export const faceSwap = {
    // 頁面標題和基本文本
    title: 'AI捏脸',
    subtitle: '智能人脸替换工具',
    description: '通過選項配置和圖片上傳，自定義生成和調整人物形象',
    
    // 主要功能標籤
    tabs: {
      textToImage: '文生圖',
      imageToImage: '圖生圖'
    },
    
    // 按鈕文本
    buttons: {
      generate: '生成',
      download: '下載',
      preview: '預覽',
      upload: '上傳圖片',
      clear: '清空',
      save: '保存',
      cancel: '取消',
      confirm: '確認',
      reset: '重置',
      random: '隨機選擇',
      clearAll: '全部清除',
      backToWorkbench: '返回工作臺'
    },
    
    // 狀態文本
    status: {
      generating: '生成中...',
      uploading: '上傳中...',
      processing: '處理中...',
      completed: '完成',
      failed: '失敗',
      ready: '就緒'
    },
    
    // 消息提示
    messages: {
      uploadSuccess: '上傳成功',
      uploadFailed: '上傳失敗',
      generateSuccess: '生成成功',
      generationSuccess: '生成成功',
      generateFailed: '生成失敗',
      invalidFile: '無效的文件格式',
      fileTooLarge: '文件過大',
      networkError: '網絡錯誤',
      generationStarted: '生成已開始',
      generationStatusError: '生成狀態錯誤',
      generationTimeout: '生成超時',
      queryStatusFailed: '查詢狀態失敗',
      uploadFirst: '請先上傳圖片',
      generateIdError: '生成ID錯誤',
      downloadFailed: '下載圖片失敗'
    },
    
    // 提示詞輸入
    prompt: {
      label: '提示詞',
      placeholder: '請輸入描述文字...',
      help: '詳細描述您想要的人物特徵'
    },
    
    // 上傳區域
    upload: {
      title: '上傳圖片',
      dragText: '拖拽圖片到此處',
      clickText: '或點擊選擇文件',
      supportedFormats: '支持 JPG、PNG 格式',
      maxSize: '最大 10MB',
      placeholder: '請上傳圖片'
    },
    
    // 結果展示
    result: {
      title: '生成結果',
      original: '原圖',
      generated: '生成圖',
      noResult: '暫無結果',
      placeholder: '生成的圖片將在這裡顯示'
    },

    // 預覽模態框
    preview: {
      title: '圖片預覽',
      imageAlt: '預覽圖片'
    },
    
    // 分類定義
    categories: {
      role: '角色',
      photography: '攝影',
      style: '風格',
      environment: '環境'
    },

    // 選項相關
    options: {
      pleaseSelect: '請選擇'
    },
  };
